<template>
  <div class="mian-article">
        <Header/>
        <div class="width1200">
          <div class="box">
            <h1>{{ $t('header.IntroductionOfPlatform') }}</h1>
            <p class="content" style="margin-bottom: 84px">{{ $t('about.p1') }}</p>
            <h1>{{ $t('about.Contactus') }}</h1>
            <img v-if="!isEnglish" src="../../assets/image/aboutUs/address2.png" alt="img" class="address">
            <img v-else src="../../assets/image/aboutUs/address3.png" alt="img" class="address">
            <div class="info-box">
              <div class="info">
                <span>{{ $t('product.Mail') }}：</span>
                <span>yaoganlist@sml-zhuhai.cn</span>
              </div>
              <div class="info">
                <span>{{ $t('DataSubmission.ContactAddress') }}：</span>
                <span>{{ $t('footer.Address2') }}</span>
              </div>
            </div>
          </div>
        </div>
        <Footer/>
  </div>
</template>

<script>
import Header from "@/components/Header"
import Footer from "@/components/Footer"
export default {
    components:{
        Header,
        Footer
    },
    data(){
        return {
          isEnglish: false
        }
    },
  mounted() {
    const language = window.localStorage.getItem('language')
    if (language === 'zh') {
      this.isEnglish = false
    }
    if (language === 'en') {
      this.isEnglish = true
    }
  },
}
</script>

<style scoped lang="scss">
    .mian-article{
      @include home_bg_t2_color();
        .width1200{
            width: 100%;
            min-height: 1118px;
            background-image: url("../../assets/image/aboutUs/bg.png");
            background-repeat: no-repeat;
            background-size: cover;
            @include co_white_to_black();
            .box{
              width: 1400px;
              min-height: 1118px;
              background-color: #FFFFFF;
              margin: 0 auto;
              padding:  58px 90px;
              box-sizing: border-box;
              .title{
                font-size: 24px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #5DA2FF;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0;
                >img{
                  width: 30px;
                  height: 30px;
                  transform: translateX(40px);
                }
              }
              .content{
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #3F444D;
                line-height: 25px;
              }
              .address{
                width: 100%;
              }
              .info-box{
                //display: flex;
                align-items: center;
                margin-top: 30px;
                justify-content: space-between;
                .info{
                  color: #3F444D;
                  font-size: 14px;
                  font-family: PingFang SC;
                  font-weight: 400;
                  margin-bottom: 10px;
                  >span:last-child{
                    color: #707780 ;
                  }
                }
              }
            }
            h1{
                text-align: center;
            }
            p{
                margin: 24px 0;
                text-indent: 2em;
            }
        }
    }
</style>